export default function(a, b) {
  return a - b;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/ascending.js
// module id = 609
// module chunks = 0